module.exports = __webpack_public_path__ + "images/assets/a565a4921b2959309ae87379988532fb.svg";